import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 500,
          autoplayTimeout: 3500,
          autoWidth: false,
          animateOut: 'fadeOut',
          autoHeight: false,
          center: true,
        });
      });
      //->カード_カルーセル 3アイテム
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 36,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>', '<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
      //->カード_カルーセル 4アイテム
      owls.imagesLoaded(function () {
        $('.js-relation-slider').owlCarousel({
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: false,
          navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>', '<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              margin: 15,
              items: 2,
            },
            // breakpoint from 750 up
            750: {
              margin: 36,
              items: 4,
            }
          }
        });
      });
    }

    function selectBoxVisible() {
      $('.c-search-box__select-button').on('click', function () {
        $('.c-search-box__select-box').toggleClass('is-active');
      });

      // 閉じるボタンクリック
      $('.c-search-box__select-close .c-button').on('click', function () {
        $('.c-search-box__select-box').removeClass('is-active');
      });
    }

    function loadingControl() {
      var $topMain = document.querySelector(".c-main-visual");
      var status = sessionStorage.getItem('loading');
      if ($topMain) {
        if (!status) {
          //スクロール禁止
          sessionStorage.setItem('loading', 'true');
        } else {
          $('.c-block-animation').addClass("is-loaded");
        }
      }
    }

    $(function () {
      menuSlide();
      owlCarousel();
      selectBoxVisible();
      loadingControl();
      if ($('body').hasClass('sitemap')) {
        $('.l-footer .l-footer__menu').hide();
      }
    });
  }
}

window.GApp = new App();
